import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"
import { SUPPLIER_ADMIN_ROUTE } from "../../../../../../constants/routes"
import { StandardTabs } from "../../../../../../shared/components/tabs/StandardTabs"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { GDPRListTab } from "../components/GDPRListTab"
import { GDPRExportsTab } from "../components/GDPRExportsTab"

export function SupplierGDPRFiles() {
    const { l10n } = useAppLocalization()

    const tabs = [
        {
            label: l10n.getString("supplier-account-gdpr-tab-documents"),
            component: <GDPRListTab />,
        },
        { label: l10n.getString("supplier-account-gdpr-tab-export"), component: <GDPRExportsTab /> },
    ]

    return (
        <>
            <LocalizedStrict id="supplier-account-gdpr-title" attrs={{ title: true }}>
                <PageHeader page={Page.SUPPLIER_GDPR} title="GDPR">
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="supplier-update-account-nav-item-home">
                            <BreadcrumbLink to={SUPPLIER_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="supplier-update-account-nav-item-account">
                            <Breadcrumb>Account</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="supplier-admin-nav-item-account-gdpr">
                            <Breadcrumb>GDPR</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>
            <StandardTabs tabs={tabs} />
        </>
    )
}
